import { useEffect, RefObject } from 'react';

/**
 * Equalizes the height of the detail cards in a section.
 * @param sectionRef
 * @param section
 * @param sectionMap
 * @param nestedSections
 */
export function useDetailCardEqualisation(sectionRef: RefObject<HTMLElement>, section, sectionMap, nestedSections) {
  useEffect(() => {
    try {
      if (!sectionRef.current) return;

      const currentSection = sectionRef.current;

      const equaliseMinHeights = () => {
        const detailCards = Array.from(
          currentSection.querySelectorAll('.paragraph--detail-card')
        ) as HTMLElement[];

        if (detailCards.length === 0) return;

        const childrenGroups = detailCards.map(card =>
          Array.from(card.children) as HTMLElement[]
        );

        const maxChildren = Math.max(...childrenGroups.map(group => group.length));

        for (let i = 0; i < maxChildren; i++) {
          const childrenAtIndex = childrenGroups
            .map(group => group[i])
            .filter(Boolean) as HTMLElement[];

          if (childrenAtIndex.length === 0) continue;

          childrenAtIndex.forEach(child => (child.style.minHeight = ''));

          const maxHeight = Math.max(...childrenAtIndex.map(child => child.offsetHeight));

          childrenAtIndex.forEach(child => (child.style.minHeight = `${maxHeight}px`));
        }
      };

      equaliseMinHeights();

      let resizeFrame: number;
      const handleResize = () => {
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(equaliseMinHeights);
      };

      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
        cancelAnimationFrame(resizeFrame);
        const topContents = Array.from(
          currentSection.querySelectorAll('.paragraph--detail-card')
        ) as HTMLElement[];
        topContents.forEach(el => (el.style.minHeight = ''));
      };
    }
    catch (error) {
      // Pass.
    }
  }, [sectionRef, section, sectionMap, nestedSections]);
}